export default "__VITE_ASSET__CTLvS1HP__"